import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { FC } from 'react';

interface IProps extends LoadingButtonProps {
  visible?: boolean;
  disabled?: boolean;
  loading?: boolean;
  disableElevation?: boolean;
}

export const FormLoadingButton: FC<IProps> = ({
  disabled = false,
  loading = false,
  visible = true,
  loadingPosition = 'start',
  size = 'medium',
  variant = 'contained',
  disableElevation = true,
  ...otherProps
}) => {
  return (
    <LoadingButton
      variant={variant}
      size={size}
      loadingPosition={loadingPosition}
      disabled={disabled}
      loading={loading}
      disableElevation={disableElevation}
      {...otherProps}
    />
  );
};
